module.exports = "<div class=\"number-field\">\r\n    <p class=\"number-label\">{{ $ctrl.modal | number: 0 }}</p>\r\n    <input class=\"number-input\" type=\"number\" ng-model=\"$ctrl.modal\" ng-change=\"$ctrl.checkLength()\" ng-readonly=\"$ctrl.readOnly\">\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/numberField/numberField.html
 ** module id = 420
 ** module chunks = 0
 **/